import { throttle } from 'lodash';
import { useEffect, useRef, useState } from 'react';

export function useThrottledValue<T>(value: T, delay: number): T {
  const [throttledValue, setThrottledValue] = useState(value);

  const throttledSet = useRef(
    throttle((v: T) => {
      setThrottledValue(v);
    }, delay)
  ).current;

  useEffect(() => {
    throttledSet(value);
  }, [value, throttledSet]);

  return throttledValue;
}
